import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const RTL_LANGS = new Set(['ar', 'he', 'fa', 'ur']);

function resolveDirection(lang) {
  const base = (lang || 'en').split('-')[0].toLowerCase();
  return RTL_LANGS.has(base) ? 'rtl' : 'ltr';
}

/**
 * Tracks i18n language, mirrors it to <html lang> and <html dir>, and returns
 * the current text direction ('ltr' | 'rtl') so callers can rebuild the MUI
 * theme with the correct `direction`.
 */
export default function useDocumentDirection() {
  const { i18n } = useTranslation();
  const [dir, setDir] = useState(() => resolveDirection(i18n.language));

  useEffect(() => {
    const apply = (lang) => {
      const next = resolveDirection(lang);
      setDir(next);
      if (typeof document !== 'undefined' && document.documentElement) {
        document.documentElement.dir = next;
        document.documentElement.lang = (lang || 'en').split('-')[0];
      }
    };
    apply(i18n.language);
    i18n.on('languageChanged', apply);
    return () => i18n.off('languageChanged', apply);
  }, [i18n]);

  return dir;
}
